<template>
    <span class="body-text" v-html="popUpBodyText"></span>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ChangeModePopUp extends Vue {
    @Prop()
    popUpData;

    get popUpBodyText() {
        if (!this.popUpData) return '';

        switch (this.popUpData.popUpType) {
            case 'SWITCH-DYNAMIC-ESS':
            case 'SWITCH-DYNAMIC-AC-ESS':
                return this.$t('dashboard.turn_on_off.dynamic_ess', {
                    i18nFallback: `You are about to turn <b> ${this.isOnText} Dynamic ESS </b>. Are you sure you want to proceed?`,
                    isOn: this.isOnText,
                });
            case 'SWITCH-RELAYS':
                return this.$t('dashboard.turn_on_off.relays', {
                    i18nFallback: `You are about to turn <b> ${this.isOnText} relay ${this.relayNumber} </b>. Are you sure you want to proceed?`,
                    isOn: this.isOnText,
                    relayNumber: this.relayNumber,
                });
            case 'SWITCH-CHARGING-STATION-CHARGE':
                return this.$t('dashboard.turn_on_off.charging-station-charge', {
                    i18nFallback: `You are about to turn <b> ${this.isOnText} charge </b>. Are you sure you want to proceed?`,
                    isOn: this.isOnText,
                });
            case 'SWITCH-AUTO-START':
                return this.$t('dashboard.turn_on_off.auto_start', {
                    i18nFallback: `You are about to turn <b> ${this.isOnText} Autostart </b>. Are you sure you want to proceed?`,
                    isOn: this.isOnText,
                });
            case 'SWITCH-TIMED-RUN':
                return this.$t('dashboard.turn_on_off.timed_run', {
                    i18nFallback: `You are about to turn <b> ${this.isOnText} timed run</b>. Are you sure you want to proceed?`,
                    isOn: this.isOnText,
                });
            case 'SWITCH-MANUAL-START':
            case 'SWITCH-MANUAL-STOP':
                return this.$t('dashboard.turn_on_off.manual_start_stop', {
                    i18nFallback: `You are about to <b> ${this.isOnText} the generator </b>. Are you sure you want to proceed?`,
                    isOn: this.isOnText,
                });
            case 'SWITCH-RESET-SERVICE':
                return this.$t('dashboard.turn_on_off.reset_service', {
                    i18nFallback: `You are about to <b> reset the service </b>. Are you sure you want to proceed?`,
                });
            default:
                return '';
        }
    }

    get isOnText() {
        const { popUpType, isOn } = this.popUpData;

        if (['SWITCH-MANUAL-START', 'SWITCH-MANUAL-STOP'].includes(popUpType)) {
            return isOn ? 'start' : 'stop';
        }

        return isOn ? 'off' : 'on';
    }

    get relayNumber() {
        return Number(this.popUpData.relayIdx) + 1;
    }
}
</script>
